import { usePublicationCategories } from "@/lib/api/hooks/publication";
import { PublicationCategory } from "@/lib/api/types";
import type { FilterSection } from "@/types/filterTypes";
import { useMemo } from "react";
    
export const usePublicationsFilterSections = (): FilterSection[] => {


  const { data: categoriesData, isFetching: isFetchingCategories, isError: isErrorCategories, refetch: refetchCategories } = usePublicationCategories();

  const categoryOptions = useMemo(() => {
    const categories = categoriesData?.data ?? [];
   
    return categories.map((cat: PublicationCategory) => {
          return {
        value: cat.value,
        label: cat.displayName,
      };
    });
  }, [categoriesData]);
  
  return [
    {
      key: "publicationCategory",
      label: "Publication Category",
      type: "select",
      options: categoryOptions,
      placeholder: isFetchingCategories ? "Loading categories..." : isErrorCategories ? "Error loading categories" : "Select category",
      isError: isErrorCategories,
      isLoading: isFetchingCategories,
      refetch: refetchCategories
    },
    {
      key: "homePageKeyResources",
      label: "Is On Home Page Key Resources?",
      type: "boolean",
    },
        {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
